export const channelApis = (http, baseUrl) => ({
    // 获取游戏包列表
    appPackageConfigList(params) {
      return http.get(`${baseUrl}/app-packet-config/`, { params })
    },
    // 获取渠道列表
    standardChannelList(params) {
      return http.get(`${baseUrl}/standard-channel-manage/`, { params })
    },
})
